import { getRedDataApiPaths } from '../config'
import { post } from '../utils/httpClient'
import { PromotionCodeSubmitResponse } from './types'

export const apiSubmitPromotionalCode = async (code: string, stepUp = false) => {
  return (await post(getRedDataApiPaths().RED_API_PROMOTIONS, true, stepUp, {
    tokenId: code,
  })) as PromotionCodeSubmitResponse
}
